export default __webpack_public_path__ + "static/media/Pin_Job_KeyReplacement_Large.30b11b55.svg";